import React from 'react';
import { Box, BoxProps, Theme } from '@mui/material';
import { useFlag } from '@unleash/proxy-client-react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';

import SnackbarProvider from './components/Snackbar/SnackbarProvider';
import { THEMES, THEME_TYPE } from './consts';
import useThemeType from './hooks/useThemeType';

interface ThemeProviderCoreProps {
  children: React.ReactNode;
  theme: Theme;
  rootNodeSx?: BoxProps['sx'];
}

export const ThemeProviderCore = ({
  children,
  theme,
  rootNodeSx,
}: ThemeProviderCoreProps) => {
  return (
    <MUIThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'inline',
          ...rootNodeSx,
          color: 'neutral.onSurface',
          '& *': {
            fontFamily: 'Lato',
          },
        }}
      >
        <SnackbarProvider>{children}</SnackbarProvider>
      </Box>
    </MUIThemeProvider>
  );
};

interface ThemeProviderProps {
  children: React.ReactNode;
  themeType?: THEME_TYPE;
  rootNodeSx?: BoxProps['sx'];
  allowDarkMode?: boolean;
}

const ThemeProvider = ({
  children,
  themeType = THEME_TYPE.LIGHT,
  rootNodeSx,
  allowDarkMode = false,
}: ThemeProviderProps) => {
  const darkModeEnabled =
    useFlag('T3-FE-OK-49218-Dark-Mode-Enabled') && allowDarkMode;
  const currentThemeType = useThemeType(themeType);

  return (
    <ThemeProviderCore
      theme={THEMES[darkModeEnabled ? currentThemeType : themeType]}
      rootNodeSx={rootNodeSx}
    >
      {children}
    </ThemeProviderCore>
  );
};

export default ThemeProvider;